'use client'
import React from 'react'
import Card from 'app/app/(client)/components/atoms/Card/Card'

const Shimmer: React.FC = () => (
  <div className="w-full mx-auto mt-6">
    <div className="animate-pulse flex flex-col gap-3 md:gap-6">
      {[...Array(8)].map((_, i) => (
        <Card id={i.toString()} key={i} className="skeleton--card rounded-2xl shadow w-full">
          <>
            <div className="block md:hidden skeleton skeleton--text" />
            <div className="skeleton skeleton--text" />
          </>
        </Card>
      ))}
    </div>
  </div>
)

export default Shimmer
